var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-radio-list',{staticClass:"mt-3",attrs:{"model":_vm.schema.replyByEpuap,"values":_vm.replyByEpuapValues}})}
var staticRenderFns = []

export { render, staticRenderFns }